import type { ReactElement } from "react";
import { memo } from "react";

import { useSelector } from "react-redux";

import { Crown } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import {
    type TabContentComponentProps,
    TabWithCounter,
} from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import { selectAppsSearchRequestDto } from "app/pages/sales-intelligence/modules/apps-search/store/selectors";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { useAppsSearchResultsQuery } from "../../query/queries/useAppsSearchResultsQuery";
import type { AppsTabId } from "../../types/page-tabs";

type Props = TabContentComponentProps<PageTabBase<AppsTabId>>;

const AppsTabContainer = ({ tab, isSelected }: Props): ReactElement => {
    const dto = useSelector(selectAppsSearchRequestDto);
    const { data, isFetching, isPending } = useAppsSearchResultsQuery(dto);

    return (
        <Flex gap="12px">
            <TabWithCounter
                isLoading={isFetching || isPending}
                isSelected={isSelected}
                total={data?.totalCount}
                iconNameActive={tab.iconNameActive}
                iconNameInactive={tab.iconNameInactive}
                title={tab.title}
                withIconFill
            />

            {salesSettingsHelper.isConsolidatedAppsEnabled ? null : (
                <Crown
                    size="xs"
                    color={colorsPalettes.indigo[300]}
                />
            )}
        </Flex>
    );
};

export default memo(AppsTabContainer);
